/**
 * Query-string overrides of the API and realtime servers (`?api=`, `?rt=`). The e2e and live suites
 * point a production build at a local server this way, but a link is not a trusted input: a crafted
 * `?api=https://evil.example` would send a signed-in player's refresh token to that server on the
 * first sync. And `?e2e=1` is a query parameter too, so gating on e2e mode alone stops nothing.
 *
 * So outside dev builds an override is honoured only when it points at this device (localhost,
 * 127.0.0.1 or ::1), where the suites run their servers; anything else is ignored and the build's
 * own server is used. Dev builds take any URL.
 */
const LOCAL_HOSTS = new Set(['localhost', '127.0.0.1', '[::1]']);

export function urlOverride(raw: string | null, dev: boolean): string | null {
  if (raw === null || dev) return raw;
  try {
    return LOCAL_HOSTS.has(new URL(raw).hostname) ? raw : null;
  } catch {
    return null;
  }
}
